import api from '@/services/api';

import {
  type AddQualityAssuranceCertificate,
  type QualityAssuranceCertificate,
  type QualityAssuranceCertificateBrief,
  type UpdateQualityAssuranceCertificate,
} from '../types';

export const createCertificate = async (procedure: AddQualityAssuranceCertificate) => {
  await api.post('qualityAssuranceCertificates', procedure);
};

export const getCertificates = async () => {
  return await api.get<QualityAssuranceCertificateBrief[]>('qualityAssuranceCertificates');
};

export const getCertificate = async (id: number) => {
  return await api.get<QualityAssuranceCertificate>(`qualityAssuranceCertificates/${id}`);
};

export const updateCertificate = async (certificate: UpdateQualityAssuranceCertificate) => {
  await api.put(`qualityAssuranceCertificates/${certificate.idQualityAssuranceCertificate}`, certificate);
};

export const deleteCertificate = async (id: number) => await api.delete(`qualityAssuranceCertificates/${id}`);
